import {createSlice} from '@reduxjs/toolkit'
import {LavanderiaModel} from '../../models'

export const EmptyLavanderiaState: LavanderiaModel = {
  showPanel: false,
  tabs: [
    {
      id: 0,
      title: 'Inicio',
      showPanel: false,
      idToEdit: '',
      idToDelete: '',
      loadingTable: false,
      content: {
        headerPanel: '',
        detailPanel: '',
      },
      submenu: 'start',
      closable: false,
      reset: false,
      currentExternalTab: 0,
      typeAdmin: '',
      aditionalInformation: null,
      isStartLaundry: false,
      isFinishLaundry: false,
      isFinishOut: false,
      isCancel: false,
      detailRow: null,
    },
  ],
  menu: [],
  currentTab: 0,
}

export const lavanderiaSlice = createSlice({
  name: 'lavanderia',
  initialState: EmptyLavanderiaState,
  reducers: {
    addTabAction: (state, action) => {
      return {...state, tabs: [...state.tabs, action.payload]}
    },
    deleteTabAction: (state, action) => {
      return {...state, tabs: action.payload}
    },
    changeTabAction: (state, action) => {
      return {...state, currentTab: action.payload}
    },
    setCurrentTabItemAction: (state, action) => {
      return {
        ...state,
        tabs: state.tabs.map((tab, idx) =>
          idx === state.currentTab ? {...tab, ...action.payload} : tab,
        ),
      }
    },
    setMenuFromApi: (state, action) => {
      return {...state, menu: action.payload}
    },
    resetCentral: () => {
      return EmptyLavanderiaState
    },
  },
})

export const {
  addTabAction,
  deleteTabAction,
  changeTabAction,
  setCurrentTabItemAction,
  resetCentral,
  setMenuFromApi,
} = lavanderiaSlice.actions

export default lavanderiaSlice.reducer
